<template>
  <div :style="{'height': selectedDivHeight + 'px'}" />
  <div 
    ref="appHeader" 
    class="app-header text-17px" 
    :class="{'fixed top-0 inset-x-0 z-20 bg-white shadow' : isSticky && isHomeRoute}"
  >
    <div class="main-container flex items-center justify-between">
      <div class="flex items-center">
        <a 
          :href="baseURL"
        >
          <AppLogo />
        </a>
        <ul class="hidden lg:flex ml-12 lg:text-sm lg2:text-base header-text">
          <li class="pr-2 lg2:pr-6" >
            <a :href="`${baseURL}`" :class="isProfilePage ? 'home-screen' : ''">Expert Sourcing</a>
          </li>
          <li class="px-2 lg2:px-6" >
            <a :href="`${baseURL}/contract-manufacturing/`">Contract Manufacturing</a>
          </li>
          <li class="px-2 lg2:px-6" >
            <a :href="`${baseURL}/buy`">Buy</a>
          </li>
          <li class="px-2 lg2:px-6" >
            <a :href="`${baseURL}/finance-page`">Financing</a>
          </li>
          <li class="pl-2 lg2:pl-6 relative" >
            <div
              @mouseenter="showAboutOptions = true"
              @mouseleave="showAboutOptions = false"
              class="flex"
            >
              <span>About Us</span>
              <img v-if="isHomeRoute && !isSticky" src="@/assets/icons/chevronDownWhite.svg" class="pl-2 w-5">
              <img v-else src="@/assets/icons/chevronDown.svg" class="pl-2 w-5">
              <transition name="slide-down">
                <div
                  v-if="showAboutOptions"
                  class="absolute z-20 left-0 top-full slide-down pt-2 px-3"
                >
                  <ul class="px-3 py-2 w-32 border rounded-lg" :class="[isLandingPage && isHomeRoute && !isSticky ? 'bg-black' : 'bg-white']">
                    <li>
                      <a :href="`${baseURL}/about-us/`" class="inline-block py-1 hover:text-green">
                        Our Story
                      </a>
                    </li>
                    <li>
                      <a :href="buyhiveHowToBuyLink" class="inline-block py-1 hover:text-green">
                        How to Buy
                      </a>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </li>
        </ul>
      </div>
      <div class="flex items-center text-green">
        <div
          v-if="isUserLoggedIn"
          class="account-area text-dark hover:text-green hover:bg-smoke-100"
          :class="{'border rounded-full border-green' : getUserAuthInfo.role === 'freelancer'}"
          @mouseenter="UserAuthRole()"
          @mouseleave="showUserOptions = false"
        >
          <img v-if="getUserAuthInfo.role === 'freelancer'" src="@/assets/icons/user.svg">
          <i v-else class="text-blue icon-account"></i>
          <span class="ml-2 pt-1" :class="getUserAuthInfo.role === 'freelancer' ? 'text-green' : 'text-blue'">
            {{ getUserAuthInfo.name }}
          </span>
          <transition name="slide-down">
            <div
              v-if="showUserOptions"
              class="user-options top-full"
              :class="getUserAuthInfo.role === 'freelancer' ? 'mt-2 bg-white' : 'pt-4 bg-transparent'"
            >
              <div 
                class="p-3 border inset-x-0 top-full rounded-lg border-dark-b"
                :class="getUserAuthInfo.role === 'freelancer' ? 'bg-theme-light' : 'bg-white'"
              >
                <ul v-if="getUserAuthInfo.role === 'buyer'" class="text-dark">
                  <li>
                    <a
                      class="block hover:text-green py-1"
                      :href="`${baseURL}/buy/profile`"
                    >
                      Account Settings
                    </a>
                  </li>
                  <li>
                    <a
                      class="block hover:text-green py-1"
                      :href="`${baseURL}/buy/profile/my-orders`"
                    >
                      My Orders
                    </a>
                  </li>
                  <li>
                    <a
                      class="block hover:text-green py-1"
                      :href="`${baseURL}/buy/profile/change-password`"
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <div
                      @click="signOut"
                      class="cursor-pointer hover:text-green py-1"
                    >
                      Logout
                    </div>
                  </li>
                </ul>
                <ul v-if="getUserAuthInfo.role === 'freelancer'" class="text-dark">
                  <!-- <li class="leading-6 py-1">Your account will be ready soon!</li>
                  <li class="leading-6 py-1">
                    Any Questions?
                    <a 
                      :href="`${baseURL}/buy/contact-us`"
                      class="text-blue underline"
                    >Contact Us</a>
                  </li> -->
                  <li>
                    <div
                      @click="signOut"
                      class="cursor-pointer hover:text-green py-1 font-semibold"
                    >
                      Logout
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </transition>
        </div>
        <template v-else>
          <!-- <router-link
            class="hidden lg:flex items-center border rounded-full border-blue px-4 py-1 mr-2"
            :class="{'bg-white': isHomeRoute && !isSticky}"
            to="/register"
          >
            <span class="text-blue">Register</span>
          </router-link> -->
          <a
            class="hidden lg:flex items-center border rounded-full border-blue px-4 py-1 mr-2 cursor-pointer"
            :class="{'bg-white': isHomeRoute && !isSticky}"
            @click="storeCurrentRoute(), openSignupSelection()"
          >
            <span class="text-blue ">Register</span>
          </a> 
          <a
            class="hidden lg:flex items-center border rounded-full border-green px-4 py-1 cursor-pointer"
            :class="{'bg-white': isHomeRoute && !isSticky}"
            @click="storeCurrentRoute(), openLoginSelection()"
          >
            <img src="@/assets/icons/user.svg">
            <span class="ml-2">Sign In</span>
          </a>
        </template> 
        <a
          v-if="!isUserLoggedIn"
          @click="storeCurrentRoute(), openLoginSelection()"
          :class="!isSticky && isHomeRoute && isLandingPage ? 'text-white' : 'text-gray-900'"
          class="md:hidden mr-2"
        >Sign In</a>
         <button class="lg:hidden pl-3" @click="isMenuNavOpen = true">
          <img src="@/assets/icons/menu.svg">
        </button>
      </div>
    </div>
    <transition name="fade">
      <AlertModal v-if="isAlertModalOpen" />
    </transition>
    <!-- <transition name="fade">
      <LoginSelection v-if="isLoginSelectionModalOpen" />
    </transition>
    <transition name="fade">
      <LoginModal v-if="isLoginModalOpen" />
    </transition>
    <transition name="fade">
      <SignUpSelection v-if="isSignupSelectionModalOpen"/>
    </transition> -->
    <transition name="fade">
      <ForgetPasswordModal v-if="isForgetPasswordModalOpen"/>
    </transition>
    <transition name="slide-fade">
      <MenuNav v-if="isMenuNavOpen" @close="isMenuNavOpen=false" />
    </transition>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AlertModal from '../../../AlertModal.vue'
import ForgetPasswordModal from '../../../modules/auth/views/forgetPasswordModal.vue'
// import LoginModal from '../../../modules/auth/views/LoginModal.vue'
// import LoginSelection from '../../../modules/auth/views/loginSelection.vue'
// import AlertModal from '../../../AlertModal.vue'
// import SignUpSelection from '../../../modules/auth/views/signUpSelection.vue'
import AppLogo from './AppLogo'
import MenuNav from './MenuNav'

export default {
  name: 'Header',
  data() {
    return {
      isMenuNavOpen: false,
      showUserOptions: false,
      showAboutOptions: false,
      buyhiveHowToBuyLink: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY,
      isSticky: false,
    }
  },
  components: { AppLogo, MenuNav, AlertModal, ForgetPasswordModal },
  computed: {
       ...mapGetters ([
      'isUserLoggedIn',
      'getUserAuthInfo',
      'isForgetPasswordModalOpen',
      'isAlertModalOpen',
      'isLoginModalOpen',
      'isLoginSelectionModalOpen',
      'isSignupSelectionModalOpen'
    ]),
    isProfilePage() {
      return this.$route.name === 'FreelancerList' ? true : false;
    },
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
    isHomeRoute() {
      return !!( this.$route.name === 'Login' || this.$route.name === 'LoginSelection' || this.$route.name === 'SignupSelection' || this.$route.name === 'Register' || this.$route.name === 'FreelancerList')
    },
    isLandingPage() {
      return false;
    },
    isAuthModule() {
      return !!(this.$route.name === 'Login' || this.$route.name === 'LoginSelection' || this.$route.name === 'SignupSelection' || this.$route.name === 'Register')
    },
    selectedDivHeight() {
      return this.isSticky && this.$refs.appHeader ? this.$refs.appHeader.clientHeight : 0
    }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  created() {
    this.isProfilePage = window.location.pathname == '/profiles' ? true : false;
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions ([
      'logout',
      'openLoginModal',
      'openAlertModal',
      'openSignupSelectionModal',
      'openLoginSelectionModal',
      'openForgetPasswordModal'
    ]),
    openLoginSelection() {
      localStorage.setItem('previousUrl', window.location)
      this.$router.push({name: 'LoginSelection'})
    },
    openSignupSelection() {
      localStorage.setItem('previousUrl', window.location)
      this.$router.push({name: 'SignupSelection'})
    },
    async signOut() {
      const result = await this.logout()
      this.showUserOptions = !result
      if (this.$route.name !== 'Home') {
        // this.$router.push({ name: 'Home' })
        window.location = process.env.VUE_APP_SERVER_BASE_URL
      }
    },
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.isSticky = currentScrollPosition > 100 ? true : false
    },
    storeCurrentRoute() {
      localStorage.setItem('previousUrl', window.location.href)
    },
    UserAuthRole() {
      if(this.getUserAuthInfo.role === 'buyer') {
        this.showUserOptions = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep().headerLogo {
  .st5{fill: white}
}
.home-screen {
  color: #00B2C9;
  font-weight: 600;
}
.app-header {
  @apply py-6;
  @screen md { @apply py-8; }
  .account-area {
    @apply hidden;
    @screen lg {
      @apply flex items-center justify-center rounded-full px-4 py-1 relative;
      min-width: 165px;
    }
    .user-options {
      @apply z-20 absolute inset-x-0 overflow-hidden duration-200 transition-transform ease-in-out;
      transform-origin: top;
    }
  }
}
.header-text {
  @media (max-width: 1027px) and (min-width: 1024px) {
    font-size: 0.775rem;
  }
  @media (max-width: 1247px) and (min-width: 1200px) {
    font-size: 0.875rem;
  }
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>
